import styled from "styled-components";

import { AXIS_INPUT_Z_INDEX } from "./AxisContainer.constants";

export const Wrapper = styled.div`
  position: absolute;
  left: 0;
  bottom: 0;
  display: flex;
  pointer-events: none;

  &.xAxis {
    right: 0;
    height: 24px;
    z-index: ${AXIS_INPUT_Z_INDEX}; // Ensure input and date picker are above legend
  }

  &.yAxis {
    top: 0;
    z-index: 1;
  }
`;
